// Render function accepting the endpoint payload structure

// Helper to get color values based on the flag
function getFlagStyles(flag) {
  const upperFlag = (flag || '').toUpperCase();
  switch (upperFlag) {
    case 'GREEN':
      return { bg: '#e8f5e9', text: '#2e7d32', border: '#a5d6a7' };
    case 'AMBER':
      return { bg: '#fff8e1', text: '#b78103', border: '#ffe082' };
    case 'RED':
    default:
      return { bg: '#ffebee', text: '#c62828', border: '#ef9a9a' };
  }
}

function renderCandidateDetails(data) {
    const container = document.getElementById('candidateProfile');
    if (!container || !data) return;

    // Compute Initials
    const firstName = data.first_name || '';
    const lastName = data.last_name || '';
    const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'NA';
 const flag = (data.recruiter_recommendation.flag || 'RED').toUpperCase();
    const flagStyles = getFlagStyles(flag);
    const summary = data.recruiter_recommendation.summary || '';
  
    // Dynamic answers template mapping
    let answersHtml = '';
    if (data.assessment_answers) {
        Object.keys(data.assessment_answers).forEach((key) => {
            const item = data.assessment_answers[key];
            answersHtml += `
        <tr>
          <td class="label-cell">${item.question || ''}</td>
          <td class="value-cell">${item.answer || 'N/A'}</td>
        </tr>
      `;
        });
    }

    container.innerHTML = `
    <!-- Header -->
    <div class="profile-header">
    <div class="evaluation-flag-card" style="background-color: ${flagStyles.bg}; border-color: ${flagStyles.border}; color: ${flagStyles.text};">
              <p>AI Recommendation:</p>
              <div class="flag-header">
                <span class="flag-badge" style="background-color: ${flagStyles.text};">${flag}</span>
                <span class="flag-summary">${summary}</span>
              </div>
            </div>
      <div class="job-title">${data.job_title || 'N/A'}</div>
        
      <div class="user-info-row">
        <div class="avatar">${initials}</div>
        <div class="user-details">
          <h2 class="user-name">${firstName} ${lastName}</h2>
          <a href="mailto:${data.email || ''}" class="user-email">${data.email || ''}</a>
          <div class="meta-tags">
            <span class="location-data">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                    <path fill="#001F3F" d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 12 8 12s8-6.75 8-12c0-4.42-3.58-8-8-8zm0 11.5A3.5 3.5 0 1 1 12 6a3.5 3.5 0 0 1 0 7.5z" />
                </svg>
                ${data.ip_address || 'N/A'}
            </span>
            ${data.vpn_connected === "Yes" || data.vpn_connected === true
            ? `<span class="vpn-badge">
                    🌐 VPN
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="10" height="10">
                        <circle cx="64" cy="64" r="64" fill="#4CAF50"/>
                        <path
                        d="M35 64 L54 83 L94 43"
                        fill="none"
                        stroke="#fff"
                        stroke-width="14"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                    </svg>
            </span>`
            : `<span class="vpn-badge">🌐 VPN 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="10" height="10">
                <circle cx="64" cy="64" r="64" fill="#F44336"/>
                <path
                    d="M40 40 L88 88 M88 40 L40 88"
                    fill="none"
                    stroke="#fff"
                    stroke-width="14"
                    stroke-linecap="round"
                />
                </svg>
            </span>`}
          </div>
          <div class="device-info">${data.browser_name || ''}</div>
          <div class="timestamp-info">${data.location_with_time || ''}</div>
        </div>
        <div class="candidate-id-badge">ID: ${data.candidate_id || 'N/A'}</div>
          
      </div>
    </div>

    <!-- Meta Summary Bar -->
    <div class="meta-summary-bar">
      <div class="bar-title">Assessment</div>
      <div class="time-details">
        <div><strong>Started:</strong> ${data.started_time || 'N/A'}</div>
        <div><strong>Completed:</strong> ${data.completed_time || 'N/A'}</div>
      </div>
    </div>

    <!-- Workday Import Section -->
    <div class="data-section">
      <div class="section-header">
        <span>Workday Import</span>
        <span class="duration">⏱ ${data.workday_import_duration}</span>
      </div>
      <table class="data-table">
        <tbody>
          <tr>
            <td class="label-cell">First Name</td>
            <td class="value-cell">${firstName}</td>
          </tr>
          <tr>
            <td class="label-cell">Last Name</td>
            <td class="value-cell">${lastName}</td>
          </tr>
          <tr>
            <td class="label-cell">Email</td>
            <td class="value-cell">${data.email || ''}</td>
          </tr>
          <tr>
            <td class="label-cell">SMS Consent:</td>
            <td class="value-cell">${data.sms_consent || 'No'}</td>
          </tr>
          <tr>
            <td class="label-cell">Phone Number:</td>
            <td class="value-cell">${data.phone || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Dynamic Assessment Section -->
    <div class="data-section">
      <div class="section-header">
        <span>Assessment</span>
        <span class="duration">⏱ ${data.assessment_duration || 'N/A'}</span>
      </div>
      <table class="data-table">
        <tbody>
          ${answersHtml}
        </tbody>
      </table>
    </div>
  `;
}

// Extract query parameters from URL
function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

// Dynamic API Fetch Function
async function fetchAndRenderCandidate(cid) {
    const container = document.getElementById('candidateProfile');

    // Default CID if none provided in URL

    // Set request headers including API key
    const myHeaders = new Headers();
    myHeaders.append("X-API-KEY", "8f3a9b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a");

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };

    try {
        if (container) {
            container.innerHTML = `<div class="ps-loading" style="padding:40px; text-align:center;">Loading candidate details...</div>`;
        }

        // Relative pathing ensures endpoint matches the current hostname dynamically
        const endpoint = `/wp-json/ps/v1/user?cid=${encodeURIComponent(cid)}`;

        const response = await fetch(endpoint, requestOptions);
        const result = await response.json();

        if (!response.ok || !result || result.status === 'error') {
            throw new Error(result?.message || 'Failed to retrieve candidate record.');
        }

        renderCandidateDetails(result.data || result);
    } catch (error) {
        console.error("Error fetching candidate details:", error);
        if (container) {
            container.innerHTML = `<div class="ps-alert ps-alert-danger" style="padding:20px; text-align:center;">❌ ${error.message}</div>`;
        }
    }
}

// Auto-execute on DOM Ready
document.addEventListener("DOMContentLoaded", () => {
    const cid = getQueryParam('cid')
    if (cid) {
        fetchAndRenderCandidate(cid);
    }
});